import { isOctaPharmaProgram } from '@/libs/util';
import { ProgramName } from '@/types/global';

import RequestDetailsCard from './RequestDetailsCard';
import StatusSteps from './StatusSteps';

interface AssistanceRequestDetailProps {
  data: any;
  program: ProgramName;
}

const AssistanceRequestDetail: React.FC<AssistanceRequestDetailProps> = ({ data, program }) => {
  const isOctaPharma = isOctaPharmaProgram(program);

  return (
    <>
      <StatusSteps status={data.status} />
      <RequestDetailsCard data={data} program={program} isOctaPharma={isOctaPharma} />
    </>
  );
};

export default AssistanceRequestDetail;
